import clsx from "clsx";
import { startCase } from "lodash";
import { FC, ReactNode } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import {
  editFormDataAF,
  EditFormMode,
  isInnerItemEditingAtom,
  TDrawerCloseFunction,
} from "@ryde/shared";

import {
  LayoutRightHeaderTitleStyled,
  LayoutRightHistoryButton,
} from "../../../right";
import {
  RelatedEntitiesHeaderIcon,
  RelatedEntitiesHeaderIconContainer,
} from "../related-entities";
import { DrawerCloseIconButton } from "./close-icon-button";
import { DrawerHeaderStyled } from "./header.styled";

interface IDrawerHeaderProps {
  title: ReactNode;
  subTitle?: string;
  onCloseDrawer: TDrawerCloseFunction;
  drawerNumber?: number;
}

export const DrawerHeader: FC<IDrawerHeaderProps> = ({
  title,
  onCloseDrawer: onClose,
  subTitle,
  drawerNumber,
}) => {
  const {
    entity,
    mode,
    data: { isEdit },
  } = useCrudEditContext();
  const dto = useRecoilValue(
    editFormDataAF([entity, mode || EditFormMode.CrudRoute]),
  );
  const isInnerItemEditing = useRecoilValue(isInnerItemEditingAtom);

  return (
    <DrawerHeaderStyled
      className={clsx(isInnerItemEditing && "inner-item-editing")}
    >
      <DrawerCloseIconButton onCloseDrawer={onClose} />
      <LayoutRightHeaderTitleStyled className="DrawerHeaderTitle">
        <RelatedEntitiesHeaderIconContainer>
          {typeof title === "string" ? startCase(title) : title}
          {isEdit && (
            <RelatedEntitiesHeaderIcon
              entity={entity}
              entityId={dto?.id}
              entityLabel={dto?.title || dto?.name}
              drawerNumber={drawerNumber}
            />
          )}
        </RelatedEntitiesHeaderIconContainer>
        {Boolean(subTitle) && (
          <span className="sub_header  animated_sub_header">{subTitle}</span>
        )}
      </LayoutRightHeaderTitleStyled>
      {isEdit && <LayoutRightHistoryButton entity={entity} dtoId={dto?.id} />}
    </DrawerHeaderStyled>
  );
};
